// The app's frame in grey while it starts: session check, memberships, and
// opening the local database. Same layout as AppShell (sidebar, header,
// content, and the sidebar as a rail when lib/sidebar.ts says so), so the real
// screen fills in place. apps/web/index.html has a
// static copy of this for the moment before any JavaScript runs.
import { Card, Skeleton } from '@ims/ui'

export function AppSkeleton({ label = 'Loading' }: { label?: string }) {
  return (
    <div role="status" aria-label={label} className="flex h-dvh overflow-hidden">
      <span className="sr-only">{label}…</span>
      <aside className="hidden w-60 shrink-0 flex-col border-r border-border bg-surface lg:flex rail:w-16">
        <div className="flex h-16 items-center gap-3 border-b border-border px-4 rail:justify-center rail:px-0">
          <Skeleton className="size-8 rounded-xl" />
          <Skeleton className="h-4 w-28 rail:hidden" />
        </div>
        <div className="space-y-2 px-3 py-4">
          <Skeleton className="mb-4 h-9 w-full rounded-xl" />
          {Array.from({ length: 8 }, (_, i) => (
            <div key={i} className="flex items-center gap-3 px-1 py-1.5 rail:justify-center">
              <Skeleton className="size-[18px] rounded-lg" />
              <Skeleton className="h-3 w-24 rail:hidden" />
            </div>
          ))}
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-16 shrink-0 items-center justify-end gap-3 border-b border-border bg-surface px-4">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="size-9 rounded-full" />
        </header>
        <main className="flex-1 overflow-hidden">
          <div className="mx-auto max-w-7xl p-4 sm:p-6">
            <div className="mb-6 space-y-2">
              <Skeleton className="h-7 w-48" />
              <Skeleton className="h-3.5 w-72 max-w-full" />
            </div>
            <div className="mb-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {Array.from({ length: 4 }, (_, i) => (
                <Card key={i} className="space-y-2">
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-6 w-28" />
                </Card>
              ))}
            </div>
            <div className="grid gap-4 lg:grid-cols-2">
              {Array.from({ length: 2 }, (_, i) => (
                <Card key={i} className="space-y-4">
                  <Skeleton className="h-4 w-36" />
                  {Array.from({ length: 4 }, (_, r) => (
                    <div key={r} className="flex items-center gap-3">
                      <Skeleton className="size-9 shrink-0 rounded-lg" />
                      <div className="flex-1 space-y-1.5">
                        <Skeleton className="h-3 w-3/5" />
                        <Skeleton className="h-2.5 w-2/5" />
                      </div>
                    </div>
                  ))}
                </Card>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
